import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { apiFetch } from "../../config/api";

export default function PaymentSuccessPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [state, setState] = useState({ loading: true });
  const guid = params.get("guid");
  const reference = params.get("reference") || params.get("token");

  useEffect(() => {
    if (!guid || !reference) {
      setState({ error: "Missing payment verification details." });
      return;
    }
    apiFetch(`/api/payment-processing/checkout/${guid}/complete/`, {
      method: "POST",
      body: { reference },
    })
      .then(({ data }) => setState(data))
      .catch((error) => setState({ error: error.response?.data?.error || "The provider has not verified this payment." }));
  }, [guid, reference]);

  return <main style={{ textAlign: "center", marginTop: 50 }}>
    <h1>{state.loading ? "Verifying payment..." : state.verified ? (state.sandbox_mode ? "Test payment verified" : "Payment successful") : "Payment not verified"}</h1>
    {state.error && <p role="alert">{state.error}</p>}
    {state.sandbox_mode && <p>This sandbox transaction did not settle the invoice.</p>}
    <button onClick={() => navigate(guid ? `/invoice/${guid}` : "/", { replace: true })}>Back to invoice</button>
  </main>;
}
